import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { startMocks } from '@/mocks/start';
import '@/index.css';

// -----------------------------------------------------------------------------
// Entry point.
//
// The mock worker is started BEFORE the first render, and awaited. Rendering
// first means the dashboard's opening request races the worker registration and
// intermittently escapes to a backend that is not there - which looks like a
// flaky network rather than a startup ordering bug.
// -----------------------------------------------------------------------------

async function bootstrap(): Promise<void> {
  const container = document.getElementById('root');
  if (!container) throw new Error('#root is missing from index.html.');

  try {
    await startMocks();
  } catch (error) {
    // A failed worker registration must not leave a blank page. The app still
    // boots and every /admin/* request simply fails with a visible error state.
    console.error('[msw] Could not start the mock worker.', error);
  }

  createRoot(container).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
}

void bootstrap();
